import { connect } from "react-redux";

import { redirectToLogin } from "actions/authActions";
import { UIFullScreenLoader } from "components/UI/Loader";
import { bindActionCreators } from "redux";
import get from "lodash.get";

export const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(
    {
      onMount() {
        const referrer = get(ownProps, "location.state.referrer", "/");
        return redirectToLogin(referrer);
      }
    },
    dispatch
  );
};

const LoginContainer = connect(
  null,
  mapDispatchToProps
)(UIFullScreenLoader);

export default LoginContainer;
